import utils from "@/lib/utils";
import { mapMutations, mapState } from "vuex";
export default {
	computed: {
		...mapState({
			locale: (state) => state.locale,
		}),
		...mapState("audio", {
			contentData: (state) => {
				if (state.content.title) {
					return state.content;
				} else {
					return state.newContent;
				}
			},
			newContentData: (state) => {
				return state.newContent;
			},
			advertiseData: (state) => state.advertise,
			itemLoading: (state) => state.itemLoading,
			memory: (state) => state.memory,
			activePlayer: (state) => state.activePlayer,
		}),
		tracks() {
			if (this.shuffle) {
				return utils.shuffle(this.newContentData.contentItems);
			} else {
				return this.newContentData.contentItems;
			}
		},
		computedMemory() {
			const aShuffleMemory = [];
			const aNumbers = this.tracks.map((item) => {
				return item.position - 1;
			});
			console.log(aNumbers)
			for (let i = 0; i < aNumbers.length; i++) {
				aShuffleMemory[i] = this.memory[aNumbers[i]];
			}

			return aShuffleMemory;
		},
		activeTrack() {
			if (this.memory && this.memory.findIndex((item) => item.active) !== -1) {
				return this.contentData.contentItems[
					this.memory.findIndex((item) => item.active)
				];
			}
			return false;
		},
		activeMemory() {
			return this.memory.find((item) => item.active);
		},
		playList() {
			let newArray = [];
			for (let i = 0; i < this.tracks.length; i++) {
				newArray.push(this.tracks[i]);
				let mm = this.memory.find(
					(item) => item.position === this.tracks[i].position
				);
				newArray[i].active = mm ? mm.active : false;
				newArray[i].currentTime = mm ? mm.currentTime : 0;
			}
			return newArray;
		},
	},
	methods: {
		prev() {
			for (let i = 0; i < this.computedMemory.length; i++) {
				if (this.computedMemory[i].active) {
					this.computedMemory[i].active = false;
					if (i !== 0) {
						this.computedMemory[i - 1].active = true;
					} else {
						this.computedMemory[this.computedMemory.length - 1].active = true;
					}
					break;
				}
			}
		},
		next() {
			for (let i = 0; i < this.computedMemory.length; i++) {
				if (this.computedMemory[i].active) {
					this.computedMemory[i].active = false;
					if (i === this.computedMemory.length - 1) {
						this.computedMemory[0].active = true;
					} else {
						console.log(this.computedMemory[i + 1].position)
						this.computedMemory[i + 1].active = true;
					}
					break;
				}
			}
		},
		toggleShuffle(payload) {
			this.shuffle = payload;
		},
		toggleRepeat(payload) {
			this.repeat = payload;
		},
		toggleActive(payload) {
			if (!this.isBox) {
				return
			}
			this.setEntityContent(["content", this.newContentData]);
			if (!this.prevented) {
				if (!this.memory.length || this.memory[0].albumId !== this.newContentData.id) {
					this.pushToMemory(this.newContentData.contentItems, this.newContentData.id);
				} else {
					for (let i = 0; i < this.memory.length; i++) {
						this.memory[i].active = false;
					}
				}

				this.setEntityContent(["activePlayer", payload.status]);
				this.memory.find((item) => item.position === payload.position).active =
					payload.status;
			}
		},
		pushToMemory(data, id) {
			this.memory.length = 0;

			for (let i = 0; i < data.length; i++) {
				this.memory.push({
					active: false,
					position: data[i].position,
					currentTime: 0,
					albumId: id,
				});
			}
		},
		onEnded(payload) {
			for (let i = 0; i < this.computedMemory.length; i++) {
				this.computedMemory[i].active = false;
			}
			let mmIndex = this.computedMemory.findIndex(
				(item) => item.position === payload.position
			);
			if (this.computedMemory[mmIndex + 1]) {
				this.computedMemory[mmIndex + 1].active = true;
			} else if (this.computedMemory[0]) {
				this.computedMemory[0].active = true;
			}
		},
		currentTimeSec(payload) {
			this.memory.find(
				(item) => item.position === payload.position
			).currentTime = payload.currentTime;

			this._streamingEvent(
				this.contentData.id,
				this.contentData.cdbId,
				payload.position,
				payload.currentTime,
				1
			);

		},
		...mapMutations("audio", {
			setEntityContent: "SET_ENTITY",
		}),
	}
}